import { render, staticRenderFns } from "./Api.vue?vue&type=template&id=5de02070"
import script from "./Api.vue?vue&type=script&lang=js"
export * from "./Api.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports